import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, setUserId } from 'firebase/analytics';
import {getEmailFromStorage} from '../../utils/helpers/storageUtils';



let firebaseConfig = {
    apiKey: process.env.REACT_APP_AUTHAPIKEY,
    authDomain: process.env.REACT_APP_AUTHDOMAIN,
    projectId: process.env.REACT_APP_PROJECTID,
    storageBucket: process.env.REACT_APP_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_APPID,
    measurementId: process.env.REACT_APP_MEASUREMENTID
};
const app = initializeApp(firebaseConfig);

export const firebaseLoadingEvent = (event) => {
    let pathname = window.location.pathname;
    let screenNameValue = '';
    if (pathname !== '' && pathname !== null && pathname !== undefined) {
        screenNameValue = pathname.split('/');
    }
    let params = {
        page_title: screenNameValue[1]
    }
    const analytics = getAnalytics(app);
    logEvent(analytics, event, params);
    if (sessionStorage.getItem('user_tracking_id') !== null) {
        setUserId(analytics, sessionStorage.getItem('user_tracking_id'))
    }
}

export const analyticsScreenViewEvent = () => {
    let pathname = window.location.pathname;
    let changeScreenname = '';
    let screenName = [];
    if (pathname !== '' && pathname !== null && pathname !== undefined) {
        screenName = pathname.split('/');
        changeScreenname = screenName[1].replaceAll('-', '_');
    }
    changeScreenname = changeScreenname + '_viewed';
    let params = {
        page_title: screenName[1],
        user_click_event: changeScreenname
    }
    const analytics = getAnalytics(app);
    logEvent(analytics, changeScreenname, params);
    if (sessionStorage.getItem('user_tracking_id') !== null) {
        setUserId(analytics, sessionStorage.getItem('user_tracking_id'))
    }
}

export const analyticsLoginSuccessEvent = (event, partnername) => {
    let pathname = window.location.pathname;
    let screenName = [];
    if (pathname !== '' && pathname !== null && pathname !== undefined) {
        screenName = pathname.split('/');
    }
    let clickEvent = '';
    if (event !== '' && event !== null && event !== undefined) {
        if (typeof (event) == 'string') {
            clickEvent = event.toLocaleLowerCase();
        } else {
            clickEvent = event;
        }
        clickEvent = clickEvent.replaceAll(' ', '_');
    }
    let pn = ''
    if (partnername !== '' && partnername !== null && partnername !== undefined) {
        pn = partnername;
    }

    let email = getEmailFromStorage();

    let params = {
        page_title: screenName[1],
        data: pn,
        user_click_event: clickEvent,
        customer_email: email
    }
    const analytics = getAnalytics(app);
    logEvent(analytics, clickEvent, params);
    if (sessionStorage.getItem('user_tracking_id') !== null) {
        setUserId(analytics, sessionStorage.getItem('user_tracking_id'))
    }

}

export const analyticsClickEvent = (event, partnername) => {
    let pathname = window.location.pathname;
    let screenName = [];
    if (pathname !== '' && pathname !== null && pathname !== undefined) {
        screenName = pathname.split('/');
    }
    let clickEvent = '';
    if (event !== '' && event !== null && event !== undefined) {
        if (typeof (event) == 'string') {
            clickEvent = event.toLocaleLowerCase() + '_clicked';
        } else {
            clickEvent = event + '_clicked';
        }
        clickEvent = clickEvent.replaceAll(' ', '_');
    }
    let pn = '';
    if (partnername !== '' && partnername !== null && partnername !== undefined) {
        pn = partnername;
    }

    let email = getEmailFromStorage();
    let params = {
        page_title: screenName[1],
        customer_email: email,
        data: pn,
        user_click_event: clickEvent
    }
    const analytics = getAnalytics(app);
    logEvent(analytics, clickEvent, params);
    if (sessionStorage.getItem('user_tracking_id') !== null) {
        setUserId(analytics, sessionStorage.getItem('user_tracking_id'))
    }

}

export const analyticsTypeEvent = (fieldname, data) => {
    let pathname = window.location.pathname;
    let screenName = [];
    if (pathname !== '' && pathname !== null && pathname !== undefined) {
        screenName = pathname.split('/');
    }
    let typeEvent = '';
    if (fieldname !== '' && fieldname !== null && fieldname !== undefined) {
        if (typeof (fieldname) == 'string') {
            typeEvent = 'type_' + fieldname.toLocaleLowerCase() + '_box';
        } else {
            typeEvent = fieldname + '_box';
        }
    }

    let params = {
        page_title: screenName[1],
        user_click_event: typeEvent
    }
    const analytics = getAnalytics(app);
    logEvent(analytics, typeEvent, params);
    if (sessionStorage.getItem('user_tracking_id') !== null) {
        setUserId(analytics, sessionStorage.getItem('user_tracking_id'))
    }
}

export const analyticsChangeEvent = (fieldname, partnername) => {
    let pathname = window.location.pathname;
    let screenName = [];
    if (pathname !== '' && pathname !== null && pathname !== undefined) {
        screenName = pathname.split('/');
    }
    let selectEvent = '';
    if (fieldname !== '' && fieldname !== null && fieldname !== undefined) {
        if (typeof (fieldname) == 'string') {
            selectEvent = fieldname.toLocaleLowerCase() + '_selected';
        } else {
            selectEvent = fieldname + '_selected';
        }
        selectEvent = selectEvent.replaceAll(' ', '_');
    }

    let pn = ''
    if (partnername !== '' && partnername !== null && partnername !== undefined) {
        pn = partnername;
    }

    let email = getEmailFromStorage();
    let params = {
        page_title: screenName[1],
        user_select_event: selectEvent,
        data: pn,
        customer_email: email
    }
    const analytics = getAnalytics(app);
    logEvent(analytics, selectEvent, params);
    if (sessionStorage.getItem('user_tracking_id') !== null) {
        setUserId(analytics, sessionStorage.getItem('user_tracking_id'))
    }
}